(function () {
  'use strict';

  var ewoRegistryCache = window.ewoDeliveryCheckerRegistry || null;
  var ewoRegistryPromise = window.ewoDeliveryCheckerRegistryPromise || null;
  var ewoModeKey = 'ewo-delivery-mode';
  var ewoPinKey = 'ewo-delivery-pin';

  function ewoBoolean(value) {
    return value === true || value === 'true';
  }

  function ewoStorageGet(key) {
    try {
      return window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function ewoStorageSet(key, value) {
    try {
      if (window.localStorage) window.localStorage.setItem(key, value);
    } catch (error) {
    }
  }

  function ewoStorageRemove(key) {
    try {
      if (window.localStorage) window.localStorage.removeItem(key);
    } catch (error) {
    }
  }

  function ewoSanitizePin(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 6);
  }

  function ewoPinSet(list) {
    var set = new Set();
    if (!Array.isArray(list)) return set;

    list.forEach(function (pin) {
      var sanitizedPin = ewoSanitizePin(pin);
      if (sanitizedPin.length === 6) set.add(sanitizedPin);
    });

    return set;
  }

  function ewoLoadRegistry(url) {
    if (ewoRegistryCache) return Promise.resolve(ewoRegistryCache);
    if (ewoRegistryPromise) return ewoRegistryPromise;

    ewoRegistryPromise = fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Registry unavailable');
      return response.json();
    }).then(function (data) {
      if (!data || !Array.isArray(data.validPins)) {
        throw new Error('Registry invalid');
      }

      ewoRegistryCache = {
        validPins: ewoPinSet(data.validPins),
        fastPins: ewoPinSet(data.fastPins),
        metroPins: ewoPinSet(data.metroPins),
        nearbyPins: ewoPinSet(data.nearbyPins),
        unavailablePins: ewoPinSet(data.unavailablePins),
        pinLocations: data.pinLocations && typeof data.pinLocations === 'object' ? data.pinLocations : {},
        metadata: data.metadata || {}
      };

      if (!ewoRegistryCache.validPins.size) {
        ewoRegistryCache = null;
        throw new Error('Registry empty');
      }

      window.ewoDeliveryCheckerRegistry = ewoRegistryCache;
      return ewoRegistryCache;
    }).catch(function (error) {
      ewoRegistryPromise = null;
      window.ewoDeliveryCheckerRegistryPromise = null;
      throw error;
    });

    window.ewoDeliveryCheckerRegistryPromise = ewoRegistryPromise;
    return ewoRegistryPromise;
  }

  function ewoIsIndiaWeekend() {
    try {
      var weekday = new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        timeZone: 'Asia/Kolkata'
      }).format(new Date());
      return weekday === 'Sat' || weekday === 'Sun';
    } catch (error) {
      var indiaTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
      var day = indiaTime.getDay();
      return day === 0 || day === 6;
    }
  }

  function ewoText(root, name) {
    return root.getAttribute('data-ewo-' + name) || '';
  }

  function ewoConfig(root) {
    return {
      pinMemory: ewoBoolean(root.getAttribute('data-ewo-pin-memory')),
      weekendNote: ewoBoolean(root.getAttribute('data-ewo-weekend-note')),
      internationalOption: ewoBoolean(root.getAttribute('data-ewo-international-option')),
      successTick: ewoBoolean(root.getAttribute('data-ewo-success-tick')),
      autoFocus: ewoBoolean(root.getAttribute('data-ewo-auto-focus')),
      enterKey: ewoBoolean(root.getAttribute('data-ewo-enter-key')),
      changeButton: ewoBoolean(root.getAttribute('data-ewo-change-button')),
      showPublicNote: ewoBoolean(root.getAttribute('data-ewo-show-public-note')),
      showHelperNote: ewoBoolean(root.getAttribute('data-ewo-show-helper-note')),
      text: {
        successTitleTemplate: ewoText(root, 'success-title-template'),
        metroEstimate: ewoText(root, 'metro-estimate'),
        nearbyEstimate: ewoText(root, 'nearby-estimate'),
        restEstimate: ewoText(root, 'rest-estimate'),
        internationalTitle: ewoText(root, 'international-title'),
        internationalEstimate: ewoText(root, 'international-estimate'),
        afterDispatch: ewoText(root, 'after-dispatch') || 'After dispatch',
        weekend: ewoText(root, 'weekend-text'),
        publicNote: ewoText(root, 'public-note'),
        internationalNote: ewoText(root, 'international-note'),
        invalid: ewoText(root, 'invalid-text') || 'Please enter a valid Indian PIN code.',
        loading: ewoText(root, 'loading-text'),
        check: ewoText(root, 'check-text'),
        unavailable: ewoText(root, 'unavailable-text'),
        unavailableNote: ewoText(root, 'unavailable-note'),
        temporaryError: ewoText(root, 'temporary-error') || 'Delivery check is temporarily unavailable. Please try again.'
      }
    };
  }

  function ewoInit(root) {
    if (!root || root.getAttribute('data-ewo-initialized') === 'true') return;
    root.setAttribute('data-ewo-initialized', 'true');

    var config = ewoConfig(root);
    var registryUrl = root.getAttribute('data-ewo-registry-url');
    var indiaPanel = root.querySelector('[data-ewo-india-panel]');
    var internationalPanel = root.querySelector('[data-ewo-international-panel]');
    var input = root.querySelector('[data-ewo-pin-input]');
    var checkButton = root.querySelector('[data-ewo-check]');
    var internationalButton = root.querySelector('[data-ewo-international]');
    var indiaButton = root.querySelector('[data-ewo-india]');
    var changeButton = root.querySelector('[data-ewo-change]');
    var result = root.querySelector('[data-ewo-result]');
    var resultTitle = root.querySelector('[data-ewo-result-title]');
    var resultEstimate = root.querySelector('[data-ewo-result-estimate]');
    var resultSubtext = root.querySelector('[data-ewo-result-subtext]');
    var resultNote = root.querySelector('[data-ewo-result-note]');
    var weekendNote = root.querySelector('[data-ewo-weekend-note]');
    var errorBox = root.querySelector('[data-ewo-error]');
    var internationalTitle = root.querySelector('[data-ewo-international-title]');
    var internationalEstimate = root.querySelector('[data-ewo-international-estimate]');
    var internationalSubtext = root.querySelector('[data-ewo-international-subtext]');
    var internationalNote = root.querySelector('[data-ewo-international-note]');

    function ewoSetHidden(element, hidden) {
      if (element) element.hidden = hidden;
    }

    function ewoClearError() {
      if (input) input.setAttribute('aria-invalid', 'false');
      if (!errorBox) return;
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    function ewoShowError(message) {
      ewoSetHidden(result, true);
      if (input) input.setAttribute('aria-invalid', 'true');
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    function ewoHideResult() {
      ewoSetHidden(result, true);
      if (resultTitle) resultTitle.textContent = '';
      if (resultEstimate) resultEstimate.textContent = '';
      if (resultSubtext) resultSubtext.textContent = '';
      if (resultNote) resultNote.textContent = '';
      if (weekendNote) {
        weekendNote.textContent = '';
        weekendNote.hidden = true;
      }
    }

    function ewoRememberMode(mode) {
      if (config.pinMemory) ewoStorageSet(ewoModeKey, mode);
    }

    function ewoForgetSavedPin() {
      if (config.pinMemory) ewoStorageRemove(ewoPinKey);
    }

    function ewoShowIndiaInput() {
      ewoSetHidden(indiaPanel, false);
      ewoSetHidden(internationalPanel, true);
      ewoClearError();
      ewoHideResult();
      ewoRememberMode('india');
    }

    function ewoShowInternational() {
      ewoSetHidden(indiaPanel, true);
      ewoSetHidden(internationalPanel, false);
      ewoClearError();
      ewoHideResult();
      if (internationalTitle) {
        internationalTitle.textContent = config.text.internationalTitle + (config.successTick ? ' \u2713' : '');
      }
      if (internationalEstimate) internationalEstimate.textContent = config.text.internationalEstimate;
      if (internationalSubtext) internationalSubtext.textContent = config.text.afterDispatch;
      if (internationalNote) internationalNote.textContent = config.text.internationalNote;
      ewoRememberMode('international');
    }

    function ewoShowUnavailable() {
      ewoClearError();
      ewoSetHidden(result, false);
      if (resultTitle) resultTitle.textContent = config.text.unavailable;
      if (resultEstimate) resultEstimate.textContent = '';
      if (resultSubtext) resultSubtext.textContent = '';
      if (resultNote) resultNote.textContent = config.text.unavailableNote;
      if (weekendNote) {
        weekendNote.textContent = '';
        weekendNote.hidden = true;
      }
    }

    function ewoResolveTier(registry, pin) {
      if (registry.metroPins.has(pin)) return 'metro';
      if (registry.nearbyPins.has(pin)) return 'nearby';
      if (!registry.metroPins.size && !registry.nearbyPins.size && registry.fastPins.has(pin)) return 'metro';
      return 'rest';
    }

    function ewoTierEstimate(tier) {
      if (tier === 'metro') return config.text.metroEstimate;
      if (tier === 'nearby') return config.text.nearbyEstimate;
      return config.text.restEstimate;
    }

    function ewoCleanLocationPart(value) {
      return String(value || '')
        .replace(/<[^>]*>/g, '')
        .replace(/\([^)]*\)/g, ' ')
        .replace(/\b(G\.?P\.?O\.?|H\.?O\.?|S\.?O\.?|B\.?O\.?|RMS|NDSO|Post Office|Sorting Office|Mail Office|Head Office|Branch Office|Sub Office)\b/gi, ' ')
        .replace(/\s+/g, ' ')
        .replace(/^[,\s]+|[,\s]+$/g, '');
    }

    function ewoSameLocation(left, right) {
      return ewoCleanLocationPart(left).toLowerCase() === ewoCleanLocationPart(right).toLowerCase();
    }

    function ewoNormalizeLocationParts(entry) {
      var rawParts = Array.isArray(entry) ? entry : String(entry || '').split(',');
      var parts = [];

      rawParts.forEach(function (part) {
        var cleanPart = ewoCleanLocationPart(part);
        if (!cleanPart) return;

        var duplicate = parts.some(function (existingPart) {
          return ewoSameLocation(existingPart, cleanPart);
        });

        if (!duplicate) parts.push(cleanPart);
      });

      if (parts.length > 1 && ewoSameLocation(parts[0], parts[1])) {
        parts.splice(0, 1);
      }

      return parts;
    }

    function ewoLocationText(registry, pin) {
      if (!registry || !registry.pinLocations) return '';

      var parts = ewoNormalizeLocationParts(registry.pinLocations[pin]);

      if (!parts.length) return '';
      return parts.join(', ');
    }

    function ewoRenderAvailabilityTitle(element, registry, pin) {
      if (!element) return;

      var location = ewoLocationText(registry, pin);
      var titleTemplate = config.text.successTitleTemplate || 'Delivery available for {pin}';
      var hasPinToken = titleTemplate.indexOf('{pin}') !== -1;
      var titleParts = hasPinToken ? titleTemplate.split('{pin}') : [titleTemplate.replace(/\s+$/g, '') + ' '];
      element.textContent = '';

      element.appendChild(document.createTextNode(titleParts[0] || 'Delivery available for '));

      var pinText = document.createElement('span');
      pinText.className = 'ewo-delivery-checker__status-pin';
      pinText.textContent = pin;
      element.appendChild(pinText);

      if (titleParts.length > 1 && titleParts[1]) {
        element.appendChild(document.createTextNode(titleParts.slice(1).join(pin)));
      }

      if (location) {
        element.appendChild(document.createTextNode(', '));
        var locationText = document.createElement('span');
        locationText.className = 'ewo-delivery-checker__status-location';
        locationText.textContent = location;
        element.appendChild(locationText);
      }

      if (config.successTick) {
        element.appendChild(document.createTextNode(' '));
        var tick = document.createElement('span');
        tick.className = 'ewo-delivery-checker__status-tick';
        tick.textContent = '\u2713';
        element.appendChild(tick);
      }
    }

    function ewoShowIndianResult(pin, tier, registry) {
      ewoClearError();
      ewoSetHidden(result, false);
      ewoRenderAvailabilityTitle(resultTitle, registry, pin);
      if (resultEstimate) resultEstimate.textContent = ewoTierEstimate(tier);
      if (resultSubtext) resultSubtext.textContent = config.text.afterDispatch;
      if (resultNote) {
        resultNote.textContent = config.showPublicNote ? config.text.publicNote : '';
        resultNote.hidden = !resultNote.textContent;
      }
      if (weekendNote) {
        weekendNote.textContent = config.weekendNote && ewoIsIndiaWeekend() ? config.text.weekend : '';
        weekendNote.hidden = !weekendNote.textContent;
      }
      ewoRememberMode('india');
      if (config.pinMemory) ewoStorageSet(ewoPinKey, pin);
    }

    function ewoCheckPin() {
      if (!input || !checkButton) return;
      var pin = ewoSanitizePin(input.value);
      input.value = pin;
      ewoClearError();

      if (pin.length !== 6 || !registryUrl) {
        ewoForgetSavedPin();
        ewoShowError(config.text.invalid);
        return;
      }

      checkButton.disabled = true;
      checkButton.textContent = config.text.loading;

      ewoLoadRegistry(registryUrl).then(function (registry) {
        if (!registry.validPins.has(pin)) {
          ewoForgetSavedPin();
          ewoShowError(config.text.invalid);
          return;
        }

        if (registry.unavailablePins.has(pin)) {
          if (config.pinMemory) ewoStorageSet(ewoPinKey, pin);
          ewoShowUnavailable();
          return;
        }

        ewoShowIndianResult(pin, ewoResolveTier(registry, pin), registry);
      }).catch(function () {
        ewoShowError(config.text.temporaryError);
      }).finally(function () {
        checkButton.disabled = false;
        checkButton.textContent = config.text.check;
      });
    }

    if (input) {
      if (config.pinMemory) {
        input.value = ewoSanitizePin(ewoStorageGet(ewoPinKey));
      } else {
        ewoStorageRemove(ewoPinKey);
        ewoStorageRemove(ewoModeKey);
      }

      input.addEventListener('input', function () {
        var next = ewoSanitizePin(input.value);
        if (input.value !== next) input.value = next;
        ewoClearError();
      });

      if (config.enterKey) {
        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            ewoCheckPin();
          }
        });
      }
    }

    if (checkButton) {
      checkButton.addEventListener('click', ewoCheckPin);
    }

    if (internationalButton) {
      internationalButton.addEventListener('click', ewoShowInternational);
    }

    if (indiaButton) {
      indiaButton.addEventListener('click', function () {
        ewoShowIndiaInput();
        if (config.autoFocus && input) input.focus();
      });
    }

    if (changeButton) {
      changeButton.addEventListener('click', function () {
        ewoShowIndiaInput();
        if (config.autoFocus && input) input.focus();
      });
    }

    if (config.internationalOption && config.pinMemory && ewoStorageGet(ewoModeKey) === 'international') {
      ewoShowInternational();
    } else {
      ewoSetHidden(indiaPanel, false);
      ewoSetHidden(internationalPanel, true);
      ewoHideResult();
      ewoClearError();
    }
  }

  function ewoInitAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-ewo-delivery-checker]').forEach(ewoInit);
  }

  if (!window.ewoDeliveryCheckerEventsBound) {
    window.ewoDeliveryCheckerEventsBound = true;
    document.addEventListener('DOMContentLoaded', function () {
      ewoInitAll(document);
    });
    document.addEventListener('shopify:section:load', function (event) {
      ewoInitAll(event.target);
    });
  }

  ewoInitAll(document);
}());
